import {
  formatLocalDate,
  greaterThanToday,
  parseDate,
  PolicyException,
  TimeFormats,
  ValidControlCode,
} from "@theprelude/core";
import { EditorIcon, ExceptionIcon, IconButton } from "@theprelude/ds";
import { useOverlay } from "@/hooks/use-overlay";
import { Callout } from "../callout";

export const ExceptionCallout = ({
  exception,
  instanceId,
  control,
  policyId,
}: {
  exception: PolicyException;
  instanceId: string;
  control: ValidControlCode;
  policyId: string;
}) => {
  const overlay = useOverlay();

  const expired =
    exception.expires && greaterThanToday(new Date(exception.expires), 0);
  const formattedExpiration =
    exception.expires &&
    formatLocalDate(parseDate(exception.expires), TimeFormats.DATE_FIRST);

  return (
    <Callout
      icon={<ExceptionIcon className="size-4" />}
      type={expired ? "error" : "notice"}
      className="mt-4 w-auto"
    >
      <span className="flex-1">
        {exception.expires &&
          expired &&
          `Exception created by ${exception.author} expired on ${formattedExpiration}`}
        {exception.expires &&
          !expired &&
          `Exception for "${exception.policy_name}" expires on ${formattedExpiration}`}
        {!exception.expires && `One or more exceptions apply to this policy`}
      </span>
      <IconButton
        icon={<EditorIcon />}
        onClick={() =>
          overlay.open("add-policy-exception", {
            instanceId,
            control,
            policyId,
          })
        }
      />
    </Callout>
  );
};
